import { IAppState } from '../common/state';
import { getLocationIdForMetro } from '../utils/geo';

export const selectLocationIdForMetroMap = (state: IAppState) => {
  return getLocationIdForMetro(state.filters.currentLocation);
};
